import { HStack, Text } from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

type BookingDiscountItemProps = {
  discount: {
    id: string;
    name: string;
    appliedAmount: number;
  };
};

export const BookingDiscountItem = ({ discount }: BookingDiscountItemProps) => {
  const { currencySymbol } = useGetClubCurrency();
  const formattedAmount = `${currencySymbol}${ConvertCentsToDollars(
    discount.appliedAmount
  )}`;

  return (
    <HStack
      justifyContent="space-between"
      style={{ marginLeft: 36 }}
      alignItems="center"
      testID={`booking-discount-${discount.name}`}
    >
      <Text variant="mainBaseMedium" color="text-success">
        {discount.name}
      </Text>
      <Text variant="mainBaseMedium" color="text-success">
        {`-${formattedAmount}`}
      </Text>
    </HStack>
  );
};
